// @flow

import { type IncomingPayment, getAddress, getPhoneNumber, getDocument, getCountry } from '@tectonics/prs/incoming-payment';
import { getSafeCountryFromCode } from '@tectonics/commons/country/country';
import { getZipcode } from '@tectonics/prs/address';
import CHILE from '@tectonics/commons/country/countries/chile';
import { getZipcodeNormalizer } from './get-zipcode-normalizer';
import { normalizeCustomerDocument } from './normalize-customer-document';
import { normalizeCustomerDocument as normalizeChileanCustomerDocument } from '@tectonics/prs/customer/chile/normalize';

export function normalizeCustomerIncomingPayment<T: IncomingPayment>(incomingPayment: T): T {
  const address = getAddress(incomingPayment);
  const rawPhoneNumber = getPhoneNumber(incomingPayment);
  const countryCode = getCountry(incomingPayment);
  const country = getSafeCountryFromCode(countryCode);
  const documentNormalizer = countryCode === CHILE.code ? normalizeChileanCustomerDocument : normalizeCustomerDocument;

  const phoneNumberConfig = country.customerForm.phoneNumber;
  const normalizedPhoneNumber = (phoneNumberConfig && phoneNumberConfig.normalizer(rawPhoneNumber)) || rawPhoneNumber;

  return {
    ...incomingPayment,
    zipcode: getZipcodeNormalizer(countryCode)(getZipcode(address)),
    phone_number: normalizedPhoneNumber,
    document: documentNormalizer(getDocument(incomingPayment)),
  };
}
